module.exports = __webpack_public_path__ + "static/media/tyre-yellow-two5.c90bd7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-two5.png
// module id = 85
// module chunks = 0